import { render, staticRenderFns } from "./test_snackbar.vue?vue&type=template&id=19c59c44"
import script from "./test_snackbar.vue?vue&type=script&lang=js"
export * from "./test_snackbar.vue?vue&type=script&lang=js"
import style0 from "./test_snackbar.vue?vue&type=style&index=0&id=19c59c44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports